import { Maybe } from '@vimeo/core/types/generic';

import { environmentConfig } from '../../configs/EnvironmentConfig';
import { EComposerSessionType } from '../../types/composer_session';

/**
 * Transforms relative link to absolute link based on current page host/protocol/domain.
 *
 * @param uri - link to transform
 * @returns URI part transformed to absolute link where needed
 */
export function transformUriToAbsolute(uri?: string): string {
  // Ignore absolute links.
  if (uri && uri.startsWith('http')) {
    return uri;
  }

  return uri ? `${environmentConfig.URL_BASE}${uri}` : '';
}

/**
 * Not all pages URLs represent same enum in their path.
 * Event and live_event are representing same thing so should be matched during parsing.
 *
 * @param rawSessionType - value to transform
 * @returns session type based on current page raw session type value
 */
export function transformUriParamToSessionType<T extends string>(
  rawSessionType: Maybe<T>,
): EComposerSessionType {
  // Shortcut for event word.
  if (rawSessionType === 'event') {
    return EComposerSessionType.LIVE_EVENT;
  } else if (Object.values(EComposerSessionType).includes(rawSessionType as EComposerSessionType)) {
    return rawSessionType as EComposerSessionType;
  } else {
    return EComposerSessionType.UNKNOWN;
  }
}

/**
 * @param sessionType - type of session to transform
 * @returns transformed session type to URI value, shortcut for better readability
 */
export function transformSessionTypeToUri(sessionType: EComposerSessionType): string {
  if (sessionType === EComposerSessionType.LIVE_EVENT) {
    return 'event';
  }

  return sessionType;
}
